import React from "react";
import { useQuery } from "@tanstack/react-query";
import { replaceUnderscoresWithSpaces } from "utils";
import { fetchInvestigationObservations } from "services/investigationManager";
import { STALE_TIME } from "utils/constants";

const InvestigationObservationAlreadyExists = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  defaultValue,
}) => {
  const key = "observation_code_id";
  const selected = watch(key);

  const {
    data,
    isLoading,
    refetch: refetchObservations,
  } = useQuery(["fetch-observations"], () => fetchInvestigationObservations(), {
    keepPreviousData: false,
    staleTime: STALE_TIME,
    select: (res) => {
      const response = res?.data?.data;
      // Filter observations based on the investigation_id from defaultValue
      const filteredObservations = response?.filter(
        (observation) => observation.investigation_id === defaultValue
      );
      return filteredObservations;
    },
    onError: (error) => {
      console.error("Error fetching observations:", error);
    },
  });

  // Filter matching records for the selected observation
  const matchingObservations = data?.filter(
    (observation) => observation.investigation_id === defaultValue
  );

  return (
    <div
      className={`observation-category-display ${selected ? "" : "is-invalid"}`}
    >
      {matchingObservations?.length > 0 ? (
        <div style={{ paddingLeft: "10px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column", // Corrected flex direction for column layout
              overflowY: "auto",
              maxHeight: "130px", // Optional: Set a max height to enable scrolling
              paddingRight: "10px", // Add padding to the right for better visual appearance
            }}
          >
            {matchingObservations.map((observation, index) => (
              <div
                key={index}
                style={{
                  marginBottom: "10px", // Space between items in the column
                }}
              >
                <p>{`${observation.observation_obj.observation}`}</p>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <p>{`No record found `}</p>
      )}
    </div>
  );

  // return (
  //     <div className={`observation-category-display ${selected ? "" : "is-invalid"}`}>
  //         {matchingObservations?.length > 0 ? (
  //             <div className="observations-container">
  //                 {matchingObservations.map((observation, index) => (
  //                         <span style={{fontSize:'15px',fontWeight:'600',color:'#747474'}}>{` ${observation.observation} ${matchingObservations?.length-1 === index ? '': ','}`}</span>
  //                 ))}
  //             </div>
  //         ) : (
  //             <p>{`No ${replaceUnderscoresWithSpaces("Observation Category")} found for the selected investigation`}</p>
  //         )}
  //     </div>
  // );
};

export default InvestigationObservationAlreadyExists;
